import { ref, get, set, remove } from 'firebase/database';
import { database } from '../firebase';

/**
 * Valida o formato da API Key do GROQ
 */
function validateGroqApiKey(apiKey) {
  if (!apiKey || typeof apiKey !== 'string') {
    return false;
  }
  // API Key do GROQ geralmente começa com 'gsk_' e tem pelo menos 20 caracteres
  const trimmed = apiKey.trim();
  return trimmed.length >= 20;
}

/**
 * Obtém a chave da API do Groq para um nutricionista
 * @param {string} nutritionistId - ID do nutricionista
 * @returns {Promise<string|null>} - A chave da API ou null se não existir
 */
export async function getGroqApiKey(nutritionistId) {
  if (!nutritionistId) {
    return null;
  }

  try {
    const apiKeyRef = ref(database, `apiKeys/${nutritionistId}/groq`);
    const snapshot = await get(apiKeyRef);
    
    if (snapshot.exists()) {
      const apiKey = snapshot.val();
      // Validar chave ao carregar
      if (validateGroqApiKey(apiKey)) {
        return apiKey;
      } else {
        // Chave inválida, remover
        await remove(apiKeyRef);
        return null;
      }
    }
    return null;
  } catch (error) {
    console.error('Erro ao buscar API Key do Groq:', error);
    return null;
  }
}

/**
 * Salva a chave da API do Groq para um nutricionista
 * @param {string} nutritionistId - ID do nutricionista
 * @param {string} apiKey - Chave da API do Groq
 * @returns {Promise<void>}
 */
export async function saveGroqApiKey(nutritionistId, apiKey) {
  if (!nutritionistId) {
    throw new Error('ID do nutricionista é obrigatório');
  }

  // Validar API Key
  if (!validateGroqApiKey(apiKey)) {
    throw new Error('API Key do GROQ inválida. A chave deve ter pelo menos 20 caracteres.');
  }

  try {
    const cleanedKey = apiKey.trim();
    const apiKeyRef = ref(database, `apiKeys/${nutritionistId}/groq`);
    await set(apiKeyRef, cleanedKey);
  } catch (error) {
    console.error('Erro ao salvar API Key do Groq:', error);
    throw new Error('Não foi possível salvar a API Key. Tente novamente.');
  }
}

/**
 * Remove a chave da API do Groq de um nutricionista
 * @param {string} nutritionistId - ID do nutricionista
 * @returns {Promise<void>}
 */
export async function clearGroqApiKey(nutritionistId) {
  if (!nutritionistId) {
    throw new Error('ID do nutricionista é obrigatório');
  }

  try {
    const apiKeyRef = ref(database, `apiKeys/${nutritionistId}/groq`);
    await remove(apiKeyRef);
  } catch (error) {
    console.error('Erro ao remover API Key do Groq:', error);
    throw new Error('Não foi possível remover a API Key. Tente novamente.');
  }
}

/**
 * Verifica se um nutricionista tem chave do Groq configurada
 * @param {string} nutritionistId - ID do nutricionista
 * @returns {Promise<boolean>}
 */
export async function hasGroqApiKey(nutritionistId) {
  const apiKey = await getGroqApiKey(nutritionistId);
  return apiKey !== null;
}




